import React from 'react';
//import { Link } from 'react-router-dom';
import AdminLayout from './AdminLayout.js';

const Subscription = () => {
  
  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-semibold text-gray-900 font-montserrat mb-8">Abonnement</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
        </div>

        <div className="mt-8 bg-amber-50 rounded-lg p-6 border border-amber-100">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-amber-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium font-montserrat text-amber-800">Brug for hjælp?</h3>
              <p className="mt-2 text-sm text-amber-700">
                Har du brug for hjælp til at komme i gang? Kontakt os på{' '}
                <a href="mailto:kontakt@haandvaerkernet.dk" className="font-medium underline">
                  kontakt@haandvaerkernet.dk
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Subscription;